import { render } from "./WalletComponent.vue?vue&type=template&id=0d77f592&scoped=true"
import script from "./WalletComponent.vue?vue&type=script&lang=js"
export * from "./WalletComponent.vue?vue&type=script&lang=js"

import "./WalletComponent.vue?vue&type=style&index=0&id=0d77f592&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d77f592"]])

export default __exports__